import React, { FC, useEffect } from 'react'

import { useService } from '@/contexts'

import { useHubspot } from './hooks/useHubspot'
import { Props } from './type'

export const ContainerAuthenticated: FC<Props> = ({ Component, pageProps }) => {
  const { current } = useService()
  const { setIdentity, setRemoveCookie } = useHubspot()

  /*
   * FIXME:
   * トラッキングAPIではなく、訪問者特定用のAPIが存在するためそちらを使用する方針を今後は取る
   * https://www.notion.so/hubspot-b19c476fa3d7499991ca4db52f713e3b
   */

  useEffect(() => {
    if (current.employee.email) {
      setRemoveCookie()
      setIdentity(current.employee.email)
    }
  }, [current])

  return <Component {...pageProps} />
}
